// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__X720N","left":"Virtual_left__Wynmn","wrapper":"Virtual_wrapper__8hzv7"};